<template>
<div class="col-12 d-flex">
    <div class="col-11" style="max-width: 924px;">
        <div class="w-100 row align-items-center needs-command-center-area pb-3">
            <div class="section-title col-3 text-right">Core Concept</div>
            <div class="section-title col-3 text-center">Value Players (9)</div>
            <div class="section-title col-2">Player Icons</div>
            <div class="section-title col-3 text-center">Value Actions (11)</div>
        </div>
        <div class="w-100 row align-items-center pb-2" v-for="(question, idxQuestion) in this.questions" v-bind:key="idxQuestion" >
            
            <template v-if="idxQuestion !== 0">
              <template v-if="idxQuestion === 1">
                <div class="col-3 text-right"><label>{{ displayQuestionName(this.questions[0]) }}<br/>{{ displayQuestionName(question) }}</label></div>
              </template>
              <template v-else>
                <div class="col-3 text-right"><label>{{ displayQuestionName(question) }}</label></div>
              </template>
              <div class="col-3 d-flex align-items-center">
                  <template v-if="idxQuestion !== 7 && idxQuestion !== 10">
                      <input v-model="playerObjectArray[idxQuestion].label" :id="`playerLabel-${idxQuestion}`" :name="`playerLabel-${idxQuestion}`" type="text" class="form-control" />
                      
                      <span class="badge rounded-circle text-dark d-flex justify-content-center align-items-center"
                              style="background-color: #e97132; width: 22px; height: 22px; font-size: 12px; font-weight: bold;">
                          {{ playerOrdinal(idxQuestion) }}
                      </span>
                  </template>
              </div>
              <div class="col-2">
                  <template v-if="idxQuestion !== 7 && idxQuestion !== 10">
                      <button type="button" class="btn btn-secondary bg-light" id="importIconButton" @click="openIconModal(playerOrdinal(idxQuestion))">
                          <span class="ml-auto">
                              <font-awesome-icon :icon="['fa', 'upload']" /> Icon
                          </span>
                      </button>
                      <span v-if="playerObjectArray[idxQuestion]?.icon" class="ml-2 align-middle">
                        <img :src="playerObjectArray[idxQuestion].icon" width="35" height="30" class="rounded" />
                      </span>
                  </template>
              </div>
              <div class="col-3 d-flex align-items-center">
                  <input v-model="playerMappingObjectArray[idxQuestion].actionText" :id="`playerMapping-${idxQuestion}`" :name="`playerMapping-${idxQuestion}`" type="text" class="form-control" />
                  <span class="badge rounded-circle text-dark d-flex justify-content-center align-items-center"
                          style="background-color: #ffc000; width: 22px; height: 22px; font-size: 12px; font-weight: bold;">
                      {{ actionOrdinal(idxQuestion) }}
                  </span>
              </div>
            </template>
        </div>
        <div class="w-100 form-row">
            <div class="col p-1">
                <button type="submit" class="btn btn-primary float-right ml-2" @click="saveValuePlayers()">
                    <span>Save</span>
                    <span v-show="this.$root.getLoading()" class="spinner-border spinner-border-sm"></span>
                </button>
            </div>
        </div>
    </div>
    <div class="col-1 align-content-center" style="overflow: visible;">
        <img src="/img/value-player/mapping.png" alt="Mapping" />
    </div>
    <import-value-player-icon @icon-selected="onIconSelected" :row-index="activeRowIndex" :value-player-icon-options="valuePlayerIconOptions"/>
    
</div>
</template>
<script>
import SectionMixins from "../mixins/SectionMixins.vue";
import ContentMixins from "../mixins/ContentMixins.vue";
import ErrorService from "../services/error.service";
import NeedsService from "../services/needs.service";
import AdminService from "../services/admin.service";
import ValuePlayerService from "../services/value.player.service";
import ImportValuePlayerIcon from "../modals/ImportValuePlayerIcon.vue";
export default {
  name: "ValuePlayer",
  mixins: [SectionMixins, ContentMixins],
  components: {
    ImportValuePlayerIcon
  },
  data() {
    return {
      questionName: "",
      segment_options: [],
      saved_segment_options: [],
      activeRowIndex: null,
      valuePlayerIconOptions: [],
      playerObjectArray: {
        type: Array,
        default: function() {
          return [{sequenceNumber:'', label:'', icon:'', playerNodeIconId:''}];
        }
      },
      playerMappingObjectArray: {
        type: Array,
        default: function() {
          return [{valuePlayerMappingTypeId:'', action:'', sequenceNumber: '', questionId: ''}];
        }
      },
      playerNodes: {
        type: Array,
        default: function() {
          return [];
        }
      },
    };
  },
  props: {
    surveyId: {
      type: Number,
      default: 0
    },
    valuePlayers: {
      type: Array,
      default: () => []
    },
    valuePlayerMapping: {
      type: Array,
      default: () => []
    }
  },
  computed: {},
  methods: {
    playerOrdinal(i) {
        const exclude = new Set([1, 7, 10]); // exclusions for nodes block
        let n = 0;
        for (let k = 0; k <= i; k++) {
          if (!exclude.has(k)) n++;
        }
        return n;
    },
    actionOrdinal(i) {
        const exclude = new Set([0]); // exclusions for actions block
        let n = 0;
        for (let k = 0; k <= i; k++) {
          if (!exclude.has(k)) n++;
        }
        return n;
    },
    displayQuestionName: function(questionObj){
      if (this.sectionObject.sectionType.name == "Functional Needs"){
        return NeedsService.getFunctionalNeedsDisplayName(questionObj);
      }
      return this.questionName;
    },
    saveValuePlayers() {
      const seen = new Set();  // added for duplicate tracking
      this.playerNodes = this.playerObjectArray.slice(1)
        .filter(p => {                 // skip duplicates
          if (seen.has(p.sequenceNumber)) return false;
          seen.add(p.sequenceNumber);
          return true;
        })
        .map(p => {
          const iconObj = (this.valuePlayerIconOptions || [])
            .find(o => String(o.valuePlayerIconId) === String(p.valuePlayerIconId));

          return {
            sequenceNumber: p.sequenceNumber,
            label: p.label,
            name: p.name,
            valuePlayerIcon: iconObj || null
          };
        });
      ValuePlayerService.saveValuePlayers(this.playerNodes, this.playerMappingObjectArray.slice(1), this.surveyId, this.saveValuePlayerNodesCallback, this);
    },
    saveValuePlayerNodesCallback(response){
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        const apiData = response.data.data || [];

        // Update playerObjectArray in place
        this.playerObjectArray = this.playerObjectArray.map(player => {
          const match = apiData.find(item => String(item.sequenceNo) === String(player.sequenceNumber));
          if (match) {
            return { ...player, label: match.label || '', valuePlayerIconId: match.valuePlayerIcon.valuePlayerIconId || '', icon: match.valuePlayerIcon.imagePath || '' };
          }
          return player;
        });
        AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
        ErrorService.processError("ValuePlayer.saveValuePlayerNodesCallback", response.data.message, "survey-designer", this);
      }
      this.$router.go(0);
    },  
    openIconModal: function(rowIdx) {
      this.activeRowIndex = rowIdx;
      this.$modal.show("value-player-icons-list");
    },
    onIconSelected({ rowIndex, icon }) {
      // Update all rows that match the sequenceNumber
      this.playerObjectArray.forEach(p => {
        if (Number(p.sequenceNumber) === Number(rowIndex)) {
          p.icon = icon.imagePath;
          p.valuePlayerIconId = icon.valuePlayerIconId;
        }
      });
    },
    getAllValuePlayerIconsCallback: function (response) {
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.valuePlayerIconOptions = response.data.data;
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    }, 
  },
  created() {
    this.playerObjectArray = [...this.questions].map((q, i) => {
      const seq = this.playerOrdinal(i);
      const match = (this.valuePlayers || []).find(v => String(v.id) === String(seq));
      return {
        sequenceNumber: seq,
        label: match?.label || '',
        name: 'Player ' + seq,
        icon: match?.icon || '',
        valuePlayerIconId: match?.valuePlayerIconId || ''
      };
    });
    this.playerMappingObjectArray = [...this.questions]
                                    .sort((a, b) => a.designViewSequenceNumber - b.designViewSequenceNumber)
                                    .map((q, i) => {
      const mappingSeq = i == 0 ? 1 : i;
      const qId = q.questionId;
      const mappingMatch = (this.valuePlayerMapping || []).find(v => String(v.id) === String(mappingSeq));
      return {
        valuePlayerMappingTypeId: mappingSeq,
        actionText: mappingMatch?.action || '',
        questionId: qId
      };
    });
    this.playerMappingObjectArray[1].questionId = this.playerMappingObjectArray[0].questionId;
  },
  async mounted() {
    if (this.sectionObject.sectionType.name == "Functional Needs"){
      this.questions.sort(function(a, b) {
        let positionA = a.designViewSequenceNumber;
        let positionB = b.designViewSequenceNumber;
        return positionA - positionB;
      });
    }
    await ValuePlayerService.getAllValuePlayerIcons(this.getAllValuePlayerIconsCallback, this);
  },
  watch: {}
};
</script>
